//#region  Start Scope: Import
import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { flightBookingRoutes } from '../../../../utils/consts';
import {
  Checkbox,
  FilterCard,
  FilterCardRangeInput,
  FlightSideBar,
} from '../../../../component';
import '../flightInformation/flightInformation.scss';
import { hasFilter } from '../../../../utils/utility/booking';
import {
  StopIcon,
  AirplaneOutlineIcon,
  CabinTypeIcon,
  AirlineIcon,
  BaggageIcon,
  ArrivalAirplaneIcon,
  DepartureAirplaneIcon,
  FlightTicketIcon,
  AirportDelayIcon,
  ClockIcon,
  UsdCircleIcon,
  DurationIcon,
  SunIcon,
  SunRiseIcon,
  MoonIcon,
  UserSettingsIcon,
} from '~svg/index';
//#endregion
//#region  Start Scope: Global Variable
let initialFlightList = [],
  selectedAirport = [],
  selectedFilter = {},
  initialSelectedFilter = {};
//#endregion
class FilterPanel extends Component {
  constructor(props) {
    super(props);
    selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport'));
    initialSelectedFilter = {
      stopCount: [],
      airline: [],
      arrivalAirportSelected: [],
      airportSelected: [],
      layoverAirportSelected: [],
      baggageSelected: [],
      cabinSelected: [],
      timeSelected: [],
      priceRangeSelected: {},
      durationSelected: [],
      flightNumberSelected: [],
      showAvailableFlight: false,
    };
    // get data from props and set them to sate
    this.state = {
      departureTimeRange: [...this.props.departTimeRange],
      priceRange: this.props.priceRange,
      durationRange: [...this.props.departDurationRange],
      stopCountLst: this.setStopCount(this.props.result),
      flightList: this.props.flightList,
    };
    initialFlightList = this.props.initialFlightList;
    selectedFilter = this.props.selectedFilter
      ? this.props.selectedFilter
      : { ...initialSelectedFilter };
  }
  //#region  Start Scope:Component life cycle
  componentDidMount() {
    this.handleScroll();
  }
  componentWillUnmount() {
    this.removeScroll();
  }
  UNSAFE_componentWillReceiveProps = (nextprops) => {
    if (nextprops !== this.props) {
      selectedFilter = nextprops.selectedFilter;
    }
  };
  //#endregion
  //#region Start Scope: Functions

  //reser all list of selected filter
  clearFlightFilter = () => {
    const { notAvailsFlights, flightList } = this.props;
    selectedFilter = {
      stopCountSelected: [],
      initialFlightList: [],
      airlineSelected: [],
      arrivalAirportSelected: [],
      airportSelected: [],
      layoverAirportSelected: [],
      baggageSelected: [],
      cabinSelected: [],
      timeSelected: [],
      priceRangeSelected: {},
      charterSelected: [],
      durationSelected: [],
      flightNumberSelected: [],
      providerSelected: [],
    };

    this.setState({
      flightList,
      notAvailsFlights,
      departureTimeRange: [...this.props.departTimeRange],
      priceRange: this.props.priceRange,
      durationRange: [...this.props.departDurationRange],
    });

    this.props.filterFunctionBySelectedFilter(selectedFilter, 0);
  };

  clearFilter = (name, index) => {
    if (index >= 0) selectedFilter[name][index] = [];
    else selectedFilter[name] = [];
    this.props.filterFunctionBySelectedFilter(selectedFilter, index);
  };
  // check each flight group and if each filter has more than 1 selected filter show just in front of each rows of filter groups
  justFilter = (value, index, name) => {
    let newArray = [];
    if (index >= 0) {
      newArray.push(
        selectedFilter[name][index].filter((itm, index) => {
          return itm === value;
        })[0],
      );
      selectedFilter[name][index] = newArray;
    } else {
      newArray.push(
        selectedFilter[name].filter((itm, index) => {
          return itm === value;
        })[0],
      );
      selectedFilter[name] = newArray;
    }
    //function to return flight with filters
    this.props.filterFunctionBySelectedFilter(selectedFilter, index, name);
  };
  //push or pop value of each filter group when checked or unchecked checkboxes
  filterFlight = (item, key, indexFlight) => {
    let value;
    if (
      key !== 'timeSelected' &&
      key !== 'priceRangeSelected' &&
      key != 'durationSelected'
    ) {
      value = item.target.value;
      if (!item.target.checked) {
        if (indexFlight >= 0)
          selectedFilter[key][indexFlight].splice(
            selectedFilter[key][indexFlight].indexOf(value.toString()),
            1,
          );
        else
          selectedFilter[key].splice(
            selectedFilter[key].indexOf(value.toString()),
            1,
          );
      } else {
        if (indexFlight >= 0) {
          if (!selectedFilter[key][indexFlight]) {
            selectedFilter[key][indexFlight] = [];
          }
          selectedFilter[key][indexFlight].push(value);
        } else selectedFilter[key].push(value);
      }
    } else {
      value = item;
      if (key !== 'priceRangeSelected') selectedFilter[key][indexFlight] = item;
      else selectedFilter[key] = item;
    }

    this.props.filterFunctionBySelectedFilter(selectedFilter, indexFlight, key);
  };

  // set stop count title for checkbox
  setStopCount = (result) => {
    let stopCountLst = [];
    if (result && result.stopCount) {
      result.stopCount.map((item, index) => {
        let stopCount = [];
        let nonStop = item.filter(function (number) {
          return parseInt(number.count) === 0;
        });
        let oneStop = item.filter(function (number) {
          return parseInt(number.count) === 1;
        });
        let moreStop = item.filter(function (number) {
          return parseInt(number.count) >= 2;
        });
        if (nonStop.length > 0)
          stopCount.push({
            //has key for message in localization
            stop: 'nonstop',
            value: 0,
            airlineCode: nonStop[0].airlineCode,
            minPrice: nonStop[0].minPrice,
          });

        if (oneStop.length > 0)
          stopCount.push({
            //has key for message in localization
            stop: 'onestop',
            value: 1,
            airlineCode: oneStop[0].airlineCode,
            minPrice: oneStop[0].minPrice,
          });
        if (moreStop.length > 0)
          stopCount.push({
            //has key for message in localization
            stop: 'morethanonestop',
            value: 2,
            airlineCode: moreStop[0].airlineCode,

            minPrice: moreStop[0].minPrice,
          });
        stopCountLst[index] = stopCount;
      });
      return stopCountLst;
    }
  };
  //reset all input range component
  resetInputRange = (type, index) => {
    switch (type) {
      case 'price':
        selectedFilter.priceRangeSelected = {};
        this.setState({
          priceRange: this.props.priceRange,
        });
        break;

      case 'departDuration':
        selectedFilter.durationSelected[index] = {};
        this.setState((state) => {
          state.durationRange[index] = {
            ...this.props.departDurationRange[index],
          };
          return state;
        });
        break;

      case 'depart':
        selectedFilter.timeSelected[index] = {};
        this.setState((state) => {
          state.departureTimeRange[index] = {
            ...this.props.departTimeRange[index],
          };
          return state;
        });
        break;
      default:
        break;
    }
  };

  updateRange = (item, index, stateName) => {
    let selectedFiletrName = '';
    switch (stateName) {
      case 'departureTimeRange':
        selectedFiletrName = 'timeSelected';
        break;
      case 'durationRange':
        selectedFiletrName = 'durationSelected';
        break;
      case 'priceRange':
        selectedFiletrName = 'priceRangeSelected';
        break;

      default:
        break;
    }

    if (index >= 0) {
      if (!selectedFilter[selectedFiletrName][index]) {
        selectedFilter[selectedFiletrName][index] = [];

        selectedFilter[selectedFiletrName][index] = item;
      } else selectedFilter[selectedFiletrName][index] = item;
      this.setState((state) => (state[stateName][index] = item));
    } else {
      if (!selectedFilter[selectedFiletrName]) {
        selectedFilter[selectedFiletrName] = [];
        selectedFilter[selectedFiletrName] = item;
      } else selectedFilter[selectedFiletrName] = item;
      this.setState((state) => {
        state[stateName] = item;
        return state;
      });
    }
  };
  //#endregion
  //#region  Start Scope: Handle Events

  handleScroll = () => {
    window.addEventListener(
      'load',
      () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      { passive: false },
    );

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  removeScroll = () => {
    window.removeEventListener('load', this.handleScroll());
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  //#endregion
  //#region  Start Scope: Render
  renderFilterPanel = () => {
    let { name, direction } = this.props.language,
      { stopCountLst, flightList, showAvailableFlight } = this.state,
      {
        stopCountAvails,
        baggaesAvails,
        cabinsAvails,
        airlineAvails,
        departAirportAvails,
        arrivalAirportAvails,
        layoverAirportAvails,
        providerAvails,
        isInternational,
        charterAvails,
      } = this.props;

    return (
      <div className={`w-100 px-2 position-relative `}>
        {/* show stopcount filter */}
        {selectedAirport.map((airport, indexFlight) => {
          let originName = `(${airport.origin.city.locationName[name]}`,
            destinationName = `${airport.destination.city.locationName[name]})`;
          /* show this filter just for international flight */
          return (
            <div key={`stopCount-${indexFlight}`}>
              <FilterCard
                filterFlight={(event, name, index) =>
                  this.filterFlight(event, name, index)
                }
                clearFilter={(name, index) => this.clearFilter(name, index)}
                message="booking.flightstopcount"
                originName={originName}
                destinationName={destinationName}
                list={stopCountLst}
                indexFlight={indexFlight}
                CheckboxValue="value"
                checkBoxLabel="stop"
                checkBoxId="chkStop"
                selectedList={selectedFilter.stopCountSelected}
                selectedListName="stopCountSelected"
                icon={<StopIcon size={20} color="#85cd95" />}
                isLocalization={true}
                hasCondition={false}
                showJust={false}
                availsFiled="value"
                type="stopCount"
                availsList={
                  stopCountAvails[indexFlight]
                    ? stopCountAvails[indexFlight]
                    : null
                }
                languageName={name}
              />
            </div>
          );
        })}
        {/* show charter filer  */}
        {selectedAirport.map((airport, indexFlight) => {
          let originName = `(${airport.origin.city.locationName[name]}`,
            destinationName = `${airport.destination.city.locationName[name]})`;
          return (
            <div key={`charterCard-${indexFlight}`}>
              <FilterCard
                languageName={name}
                filterFlight={(event, name, index) =>
                  this.filterFlight(event, name, index)
                }
                clearFilter={(name, index) => this.clearFilter(name, index)}
                justFilter={(value, index, name) =>
                  this.justFilter(value, index, name)
                }
                message="booking.type"
                originName={originName}
                destinationName={destinationName}
                list={this.props.charter}
                indexFlight={indexFlight}
                CheckboxValue="isCharter"
                checkBoxLabel=""
                checkBoxId="chkCharter"
                selectedList={selectedFilter.charterSelected}
                type="charter"
                selectedListName="charterSelected"
                icon={<AirplaneOutlineIcon size={20} color="#85cd95" />}
                isLocalization={false}
                showJust={true}
                availsFiled="value"
                availsList={
                  charterAvails[indexFlight] ? charterAvails[indexFlight] : null
                }
              />
            </div>
          );
        })}

        {/* show cabin class filer  */}
        {selectedAirport.map((airport, indexFlight) => {
          let originName = `(${airport.origin.city.locationName[name]}`,
            destinationName = `${airport.destination.city.locationName[name]})`;
          return (
            <div key={`cabinCard-${indexFlight}`}>
              <FilterCard
                languageName={name}
                filterFlight={(event, name, index) =>
                  this.filterFlight(event, name, index)
                }
                clearFilter={(name, index) => this.clearFilter(name, index)}
                justFilter={(value, index, name) =>
                  this.justFilter(value, index, name)
                }
                message="booking.cabin"
                originName={originName}
                destinationName={destinationName}
                list={this.props.cabins}
                indexFlight={indexFlight}
                CheckboxValue="name"
                checkBoxLabel="name"
                checkBoxId="chkCabin"
                selectedList={selectedFilter.cabinSelected}
                selectedListName="cabinSelected"
                checkName={true}
                icon={<CabinTypeIcon size={20} color="#85cd95" />}
                isLocalization={false}
                showJust={true}
                availsFiled="name"
                availsList={
                  cabinsAvails[indexFlight] ? cabinsAvails[indexFlight] : null
                }
              />
            </div>
          );
        })}

        {/* show airline filter  */}
        {selectedAirport.map((airport, indexFlight) => {
          let originName = `(${airport.origin.city.locationName[name]}`,
            destinationName = `${airport.destination.city.locationName[name]})`;
          return (
            <div key={`airline-${indexFlight}`}>
              <FilterCard
                languageName={name}
                filterFlight={(event, name, index) =>
                  this.filterFlight(event, name, index)
                }
                clearFilter={(name, index) => this.clearFilter(name, index)}
                justFilter={(value, index, name) =>
                  this.justFilter(value, index, name)
                }
                message="booking.airline"
                originName={originName}
                destinationName={destinationName}
                list={this.props.airLineLst}
                indexFlight={indexFlight}
                CheckboxValue="name"
                checkBoxLabel="name"
                checkBoxId="chkAirline"
                checkName={true}
                selectedList={selectedFilter.airlineSelected}
                selectedListName="airlineSelected"
                type="airline"
                icon={<AirlineIcon size={24} color="#85cd95" />}
                isLocalization={false}
                showJust={true}
                finalList={flightList}
                availsFiled="name"
                availsList={
                  airlineAvails[indexFlight] ? airlineAvails[indexFlight] : null
                }
              />
            </div>
          );
        })}
        {/* show baggage filer  */}
        {selectedAirport.map((airport, indexFlight) => {
          let originName = `(${airport.origin.city.locationName[name]}`,
            destinationName = `${airport.destination.city.locationName[name]})`;
          return (
            <div key={`baggaeCard-${indexFlight}`}>
              <FilterCard
                languageName={name}
                filterFlight={(event, name, index) =>
                  this.filterFlight(event, name, index)
                }
                clearFilter={(name, index) => this.clearFilter(name, index)}
                justFilter={(value, index, name) =>
                  this.justFilter(value, index, name)
                }
                message="booking.baggages"
                originName={originName}
                destinationName={destinationName}
                list={this.props.baggages}
                indexFlight={indexFlight}
                CheckboxValue="Index"
                checkBoxLabel=""
                checkBoxId="chkBaggage"
                selectedList={selectedFilter.baggageSelected}
                type="baggage"
                selectedListName="baggageSelected"
                icon={<BaggageIcon size={20} color="#85cd95" />}
                isLocalization={false}
                showJust={true}
                availsFiled="Index"
                availsList={
                  baggaesAvails[indexFlight] ? baggaesAvails[indexFlight] : null
                }
              />
            </div>
          );
        })}

        {selectedAirport.map((airport, indexFlight) => {
          let originName = `(${airport.origin.city.locationName[name]}`,
            destinationName = `${airport.destination.city.locationName[name]})`;

          /* show this filter just for international flight */
          return (
            <div
              className="card py-2 my-2 bg-primary text-white  border-top-0 border-right-0 border-left-0 border-bottom border-bottom-1  border-light rounded-0"
              key={`filterFlightNo-${indexFlight}`}
            >
              <div
                className={`d-flex justify-content-between align-items-center font-weight-bold text-white border-0 bg-primary card-header font-small px-0 align-items-center ${
                  name === 'fa' ? 'text-right' : 'text-left'
                }`}
              >
                <div className="d-flex flex-start align-items-center">
                  <FlightTicketIcon size={24} color="#85cd95" />
                  <span className={`${'font-small'} text-captalize  px-1`}>
                    <FormattedMessage id="booking.flightno" />
                  </span>
                </div>
                <div className="d-flex flex-grow-1 align-items-center">
                  <span className="font-smaller">{`${originName} - ${destinationName}`}</span>
                </div>
              </div>
              <div className="d-flex w-100 card-body bg-primary border-0 text-white border-0 flightNumber">
                <div className="w-100">
                  <input
                    className="flight-number-input"
                    autoComplete="nope"
                    type={'text'}
                    name={`flightNumbrer-${indexFlight}`}
                    value={
                      selectedFilter &&
                      selectedFilter.flightNumberSelected &&
                      selectedFilter.flightNumberSelected.length &&
                      selectedFilter.flightNumberSelected[indexFlight]
                        ? selectedFilter.flightNumberSelected[indexFlight]
                        : ''
                    }
                    placeholder="Mahan-763"
                    // error={this.state.errors[`${field}-${gate._id}`]}
                    onChange={(event) => {
                      selectedFilter.flightNumberSelected[indexFlight] =
                        event.target.value;

                      this.setState({ selectedFilter }, () =>
                        this.props.filterFunctionBySelectedFilter(
                          selectedFilter,
                          indexFlight,
                          'flightNumber',
                        ),
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}

        {/* take off time for each flight*/}
        {this.props.departTimeRange &&
          selectedAirport.map((airport, indexFlight) => {
            let originName = airport.origin.city.locationName[name];

            return (
              <div key={`departureTimeRange-${indexFlight}`}>
                <FilterCardRangeInput
                  languageName={name}
                  filterFlight={(event, name, index) =>
                    this.filterFlight(event, name, index)
                  }
                  resetInputRange={(type, index) =>
                    this.resetInputRange(type, index)
                  }
                  updateRange={(item, index, name) =>
                    this.updateRange(item, index, name)
                  }
                  filterFunction={(key, index) =>
                    this.props.filterFunctionBySelectedFilter(
                      selectedFilter,
                      indexFlight,
                      'timeSelected',
                    )
                  }
                  message="booking.takeofffrom"
                  originName={originName}
                  list={this.props.departTimeRange}
                  indexFlight={indexFlight}
                  selectedList={selectedFilter.timeSelected}
                  selectedListName="timeSelected"
                  selectedValue={
                    selectedFilter.timeSelected[indexFlight] &&
                    selectedFilter.timeSelected[indexFlight].hasOwnProperty(
                      'min',
                    )
                      ? selectedFilter.timeSelected[indexFlight]
                      : this.state.departureTimeRange[indexFlight]
                  }
                  updateRangeName="departureTimeRange"
                  icon1={<SunRiseIcon size={20} color="goldenrod" />}
                  icon2={<SunIcon size={20} color="goldenrod" />}
                  icon3={<MoonIcon size={20} color="goldenrod" />}
                  headerIcon={<ClockIcon size={26} color="#85cd95" />}
                  resetRangeName="depart"
                  finalList={flightList}
                />
              </div>
            );
          })}
        {/* duration time for international flight */}
        {isInternational
          ? selectedAirport.map((airport, indexFlight) => {
              let originName = `${airport.origin.city.locationName[name]}`,
                destinationName = `${airport.destination.city.locationName[name]}`;
              return (
                <div key={`durationRange-${indexFlight}`}>
                  <FilterCardRangeInput
                    languageName={name}
                    filterFlight={(event, name, index) =>
                      this.filterFlight(event, name, index)
                    }
                    resetInputRange={(type, index) =>
                      this.resetInputRange(type, index)
                    }
                    updateRange={(item, index, name) =>
                      this.updateRange(item, index, name)
                    }
                    filterFunction={(key, index) =>
                      this.props.filterFunctionBySelectedFilter(
                        selectedFilter,
                        indexFlight,
                        'durationRange',
                      )
                    }
                    message="booking.duration"
                    originName={originName}
                    destinationName={destinationName}
                    list={this.props.departDurationRange}
                    indexFlight={indexFlight}
                    selectedList={selectedFilter.durationSelected[indexFlight]}
                    selectedListName="durationSelected"
                    selectedValue={
                      selectedFilter.durationSelected[indexFlight] &&
                      selectedFilter.durationSelected[
                        indexFlight
                      ].hasOwnProperty('min')
                        ? selectedFilter.durationSelected[indexFlight]
                        : this.state.durationRange[indexFlight]
                    }
                    updateRangeName="durationRange"
                    headerIcon={<DurationIcon size={22} color="#85cd95" />}
                    applyStyle={true}
                    resetRangeName="departDuration"
                    finalList={flightList}
                  />
                </div>
              );
            })
          : null}

        {/* price of  each flight*/}
        <FilterCardRangeInput
          languageName={name}
          filterFlight={(event, name, index) =>
            this.filterFlight(event, name, index)
          }
          resetInputRange={(type, index) => this.resetInputRange(type, index)}
          updateRange={(item, index, name) =>
            this.updateRange(item, index, name)
          }
          filterFunction={(key, index) =>
            this.props.filterFunctionBySelectedFilter(
              selectedFilter,
              -1,
              'priceRange',
            )
          }
          message="booking.price"
          list={this.props.priceRange}
          indexFlight={-1}
          selectedList={selectedFilter.priceRangeSelected}
          selectedListName="priceRangeSelected"
          selectedValue={
            selectedFilter.priceRangeSelected &&
            selectedFilter.priceRangeSelected.hasOwnProperty('min')
              ? selectedFilter.priceRangeSelected
              : this.state.priceRange
          }
          updateRangeName="priceRange"
          headerIcon={<UsdCircleIcon size={22} color="#85cd95" />}
          resetRangeName="price"
          applyStyle={false}
          finalList={flightList}
        />

        {/* show departure airport filter  */}
        {isInternational
          ? selectedAirport.map((airport, indexFlight) => {
              let originName = `(${airport.origin.city.locationName[name]}`,
                destinationName = `${airport.destination.city.locationName[name]})`;
              return (
                <div key={`departAirport-${indexFlight}`}>
                  <FilterCard
                    languageName={name}
                    filterFlight={(event, name, index) =>
                      this.filterFlight(event, name, index)
                    }
                    clearFilter={(name, index) => this.clearFilter(name, index)}
                    justFilter={(value, index, name) =>
                      this.justFilter(value, index, name)
                    }
                    message="booking.departureairport"
                    originName={originName}
                    destinationName={destinationName}
                    list={this.props.airportLst}
                    indexFlight={indexFlight}
                    CheckboxValue="iata"
                    checkBoxLabel="name"
                    checkBoxId="chkAirport"
                    checkName={true}
                    selectedList={selectedFilter.airportSelected}
                    selectedListName="airportSelected"
                    type="airport"
                    icon={<DepartureAirplaneIcon size={20} color="#85cd95" />}
                    isLocalization={false}
                    condition={'isDepartureAirport'}
                    hasCondition={true}
                    showJust={true}
                    finalList={flightList}
                    availsFiled="iata"
                    availsList={
                      departAirportAvails[indexFlight]
                        ? departAirportAvails[indexFlight]
                        : null
                    }
                  />
                </div>
              );
            })
          : null}

        {/* shown arrival airport filter  */}
        {isInternational
          ? selectedAirport.map((airport, indexFlight) => {
              let originName = `(${airport.origin.city.locationName[name]}`,
                destinationName = `${airport.destination.city.locationName[name]})`;
              return (
                <div key={`arrivalAirport-${indexFlight}`}>
                  <FilterCard
                    languageName={name}
                    filterFlight={(event, name, index) =>
                      this.filterFlight(event, name, index)
                    }
                    clearFilter={(name, index) => this.clearFilter(name, index)}
                    justFilter={(value, index, name) =>
                      this.justFilter(value, index, name)
                    }
                    message="booking.arrivalairport"
                    originName={originName}
                    destinationName={destinationName}
                    list={this.props.airportLst}
                    indexFlight={indexFlight}
                    CheckboxValue="iata"
                    checkBoxLabel="name"
                    checkBoxId="chkArrivalAirport"
                    checkName={true}
                    selectedList={selectedFilter.arrivalAirportSelected}
                    selectedListName="arrivalAirportSelected"
                    type="airport"
                    icon={<ArrivalAirplaneIcon size={20} color="#85cd95" />}
                    isLocalization={false}
                    condition={'isArrivalAirport'}
                    hasCondition={true}
                    showJust={true}
                    finalList={flightList}
                    availsFiled="iata"
                    availsList={
                      arrivalAirportAvails[indexFlight]
                        ? arrivalAirportAvails[indexFlight]
                        : null
                    }
                  />
                </div>
              );
            })
          : null}

        {/* shown layover airport filter  */}
        {isInternational ? (
          selectedAirport.map((airport, indexFlight) => {
            let originName = `(${airport.origin.city.locationName[name]}`,
              destinationName = `${airport.destination.city.locationName[name]})`;
            return (
              <div key={`layOverAirport-${originName}-${indexFlight}`}>
                <FilterCard
                  languageName={name}
                  filterFlight={(event, name, index) =>
                    this.filterFlight(event, name, index)
                  }
                  clearFilter={(name, index) => this.clearFilter(name, index)}
                  justFilter={(value, index, name) =>
                    this.justFilter(value, index, name)
                  }
                  message="booking.layoverairports"
                  originName={originName}
                  destinationName={destinationName}
                  list={this.props.airportLst}
                  indexFlight={indexFlight}
                  CheckboxValue="iata"
                  checkBoxLabel="name"
                  checkBoxId="chkLayOverAirport"
                  checkName={true}
                  selectedList={selectedFilter.layoverAirportSelected}
                  selectedListName="layoverAirportSelected"
                  type="airport"
                  icon={<AirportDelayIcon size={32} color="#85cd95" />}
                  isLocalization={false}
                  condition={'isUsedForStop'}
                  hasCondition={true}
                  showJust={true}
                  finalList={flightList}
                  availsFiled="iata"
                  availsList={
                    layoverAirportAvails[indexFlight]
                      ? layoverAirportAvails[indexFlight]
                      : null
                  }
                />
              </div>
            );
          })
        ) : (
          <></>
        )}
        {/* show provider filter  */}
        {this.props.showProvider
          ? selectedAirport.map((airport, indexFlight) => {
              let originName = `(${airport.origin.city.locationName[name]}`,
                destinationName = `${airport.destination.city.locationName[name]})`;
              return (
                <div key={`provider-${indexFlight}`}>
                  <FilterCard
                    languageName={name}
                    filterFlight={(event, name, index) =>
                      this.filterFlight(event, name, index)
                    }
                    clearFilter={(name, index) => this.clearFilter(name, index)}
                    justFilter={(value, index, name) =>
                      this.justFilter(value, index, name)
                    }
                    message="booking.providergateway"
                    originName={originName}
                    destinationName={destinationName}
                    list={this.props.providerLst}
                    indexFlight={indexFlight}
                    CheckboxValue="id"
                    checkBoxLabel="Code"
                    checkBoxId="chkProvider"
                    checkName={false}
                    selectedList={selectedFilter.providerSelected}
                    selectedListName="providerSelected"
                    type="provider"
                    icon={<UserSettingsIcon size={20} color="#85cd95" />}
                    isLocalization={false}
                    showJust={true}
                    finalList={flightList}
                    availsFiled="id"
                    availsList={
                      providerAvails[indexFlight]
                        ? providerAvails[indexFlight]
                        : null
                    }
                  />
                </div>
              );
            })
          : null}
        {/* show available filter  */}

        <div className="d-flex w-100 my-3">
          <Checkbox
            isLocalization={true}
            id="availableCheckBox"
            label="booking.showavailableflight"
            name={`checkBoxAvailability`}
            inputClassName="mb-0 text-white"
            checked={showAvailableFlight}
            onChange={() => {
              this.setState(
                { showAvailableFlight: !showAvailableFlight },
                () => {
                  this.props.changeAvailbleFlight(
                    this.state.showAvailableFlight,
                  );
                },
              );
            }}
          />
        </div>

        <div
          style={{ minHeight: '25vh' }}
          className=" d-flex d-lg-none d-block w-100 justify-content-between align-items-center pb-5 pt-3 bg-transparent  cursor-pointer"
        >
          <div
            className={`bg-primary-light text-white default-border-radius col-5  font-small p-2  tex-captalize d-flex align-items-center justify-content-center `}
            onClick={() => this.clearFlightFilter()}
          >
            <FormattedMessage
              id="booking.clearfilter"
              defaultMessage="booking.clearfilter"
            />
          </div>
          <div
            className={`btn-secondary col-5 font-small p-2 default-border-radius tex-captalize d-flex align-items-center justify-content-center text-white `}
            onClick={() => this.props.hideFilterPanel()}
          >
            <FormattedMessage
              id="booking.apply"
              defaultMessage="booking.apply"
            />
          </div>
        </div>
      </div>
    );
  };

  // render flight count and clear all link in top of filter compnent
  renderflightCount = () => {
    return (
      <React.Fragment>
        <div className="d-flex flex-grow-1 font-weight-bold text-dark flex-start font-small py-2 px-0">
          <span className="px-1 text-secondary text-small ">
            {this.props.flightCount}
          </span>
          <FormattedMessage
            id="booking.flightscount"
            defaultMessage="booking.flightscount"
          />
        </div>
        {/* show clear all link in top of filter compnent */}
        {hasFilter(selectedFilter) && (
          <div
            className="linkableDiv text-primary font-weight-bold font-small 
						pointer px-1 d-flex flex-end justify-content-end cursor-pointer"
            onClick={() => this.clearFlightFilter()}
          >
            <FormattedMessage
              id="booking.clearallfilter"
              defaultMessage="booking.clearallfilter"
            />
          </div>
        )}
      </React.Fragment>
    );
  };
  render() {
    if (this.props)
      return (
        <FlightSideBar
          backButtonClick={() => this.props.backButtonClick()}
          currentPage={flightBookingRoutes.selectFlight}
          parsedQueryStr={this.props.parsedQueryStr}
          renderFilterPanel={() => this.renderFilterPanel()}
          changeStakHolder={() => this.props.changeStakHolder()}
          hasFilter={hasFilter(selectedFilter)}
          clearFlightFilter={() => this.clearFlightFilter()}
          searchPassengers={() => this.props.changeStakHolder()}
          hideFilterPanel={() => this.props.hideFilterPanel()}
          filterPanelFlag={this.props.filterPanelFlag}
        />
      );

    return <></>;
  }
  //#endregion
}

function mapStateToProps(state, props) {
  return {
    users: state.user,
    language: state.language,
  };
}
//#region propTypes and defaultProps
FilterPanel.propTypes = {
  flightList: propTypes.array,
  notAvailsFlights: propTypes.array,
  layoverAirportAvails: propTypes.array,
  arrivalAirportAvails: propTypes.array,
  stopCountAvails: propTypes.array,
  baggaesAvails: propTypes.array,
  cabinsAvails: propTypes.array,
  airlineAvails: propTypes.array,
  departAirportAvails: propTypes.array,
  selectedFilter: propTypes.object,
  initialFlightList: propTypes.array,
  result: propTypes.object,
  flightTyp: propTypes.string,
  airLineLst: propTypes.array,
  airportLst: propTypes.array,
  layoverAirportLst: propTypes.array,
  baggages: propTypes.array,
  cabins: propTypes.array,
  priceRange: propTypes.object,
  departDurationRange: propTypes.array,
  departTimeRange: propTypes.array,
  clearAllFilter: propTypes.bool,
  flightCount: propTypes.number,
  isInternational: propTypes.bool,
  sortBy: propTypes.string,
  sortType: propTypes.string,
  filterFunctionBySelectedFilter: propTypes.func,
};
FilterPanel.defaultProps = {
  flightList: [],
  notAvailsFlights: [],
  layoverAirportAvails: [],
  arrivalAirportAvails: [],
  stopCountAvails: [],
  baggaesAvails: [],
  cabinsAvails: [],
  airlineAvails: [],
  departAirportAvails: [],
  selectedFilter: {},
  initialFlightList: [],
  result: {},
  flightTyp: 'oneway',
  airLineLst: [],
  airportLst: [],
  layoverAirportLst: [],
  baggages: [],
  cabins: [],
  priceRange: {},
  departDurationRange: [],
  departTimeRange: [],
  flightCount: 0,
  isInternational: false,
  sortType: 'asc',
  clearAllFilter: false,
  filterFunctionBySelectedFilter: () => {
    console.error(
      "FilterPanel  component hasn't filterFunctionBySelectedFilter functon",
    );
  },
};
//#endregion
export default injectIntl(connect(mapStateToProps)(withRouter(FilterPanel)));
